<template>
	<div class="container">
		<div class="content">
			<div class="card mb_0">
				<h3 id="selectAsset" class="title mb_15">
					{{ $t('rtr_pay-deposit.title1') }}
				</h3>
				<div class="mb_20">
					<AccountPicker @changeAccount="getAccountInfo"></AccountPicker>
					<div v-if="selectedAccountInfo" class="bg_black_box">
						<div class="d_flex flex_column">
							<div class="asset_box">
								<span
									:class="[selectedAccountInfo?.asset_code, 'small']"
								></span>
								<p class="code mr_4">{{ selectedAccountInfo?.asset_code }}</p>
								<p class="name">{{ selectedAccountInfo?.asset_title }}</p>
							</div>
							<span class="divide_line"></span>
							<div class="num_unit">
								<p class="num">{{ selectedAccountInfo?.balance }}</p>
								<p class="unit">{{ selectedAccountInfo?.asset_code }}</p>
							</div>
						</div>
					</div>
				</div>
				<h3 id="selectWay" class="title mb_15">
					{{ $t('rtr_pay-deposit.title2') }}
				</h3>
				<div class="mb_20">
					<swiper
						:slidesPerView="1.5"
						:space-between="10"
						:modules="modules"
						class="mb_15"
					>
						<swiper-slide
							><div>
								<input
									type="radio"
									id="way1"
									class="radio_way"
									v-model="selectedWay"
									name="selectWay"
									value="way1"
									@click="selectWay"
								/>
								<label for="way1" class="box type_01">
									<span class="coin_icon way_01"></span>
									<span class="coin_name">{{
										$t('rtr_pay-deposit.text1')
									}}</span>
								</label>
							</div></swiper-slide
						>
						<swiper-slide
							v-if="
								!selectedAccountInfo ||
								['USDT', 'USOT'].indexOf(selectedAccountInfo?.code) !== -1
							"
							><div>
								<input
									type="radio"
									id="way2"
									class="radio_way"
									v-model="selectedWay"
									name="selectWay"
									value="way2"
									@click="selectWay"
								/>
								<label for="way2" class="box type_01">
									<span class="coin_icon way_02"></span>
									<span class="coin_name">
										{{ $t('rtr_pay-deposit.text2') }}
									</span>
								</label>
							</div></swiper-slide
						>
						<swiper-slide
							><div>
								<input
									type="radio"
									id="way3"
									class="radio_way"
									v-model="selectedWay"
									name="selectWay"
									value="way3"
									@click="selectWay"
								/>
								<label for="way3" class="box type_01">
									<span class="coin_icon way_03"></span>
									<span class="coin_name">{{
										$t('rtr_pay-deposit.text3')
									}}</span>
								</label>
							</div></swiper-slide
						>
					</swiper>

					<div class="">
						<div v-show="this.showTab === 'way1'">
							<div class="mb_20">
								<p class="mb_10">{{ $t('rtr_pay-deposit.text4') }}</p>
								<div class="es_search">
									<input
										type="text"
										:value="selectedAccountInfo?.account_number"
										readonly
									/>
								</div>
							</div>
						</div>

						<div v-show="this.showTab === 'way2'">
							<div class="mb_20">
								<p class="mb_10">{{ $t('rtr_pay-deposit.text5') }}</p>
								<div class="es_search">
									<input
										type="text"
										:value="selectedAccountInfo?.address"
										readonly
									/>
								</div>
							</div>
						</div>
						<div v-show="this.showTab === 'way3'">
							<invoice
								ref="invoice"
								:assetSeq="selectedAccountInfo?.asset_seq"
								@change="setInvoiceData"
							/>
						</div>
					</div>
				</div>
				<div class="button_area">
					<button @click="toDashboard">
						{{ $t('button.cancel') }}
					</button>
					<button class="button_bg_red" @click="onRequestHandler">
						{{ $t('button.request') }}
					</button>
				</div>
			</div>
		</div>
	</div>
	<ModalMessageM
		v-if="messageModal"
		@closeModal="messageModalCloseHandler('close')"
	>
		<div :class="'status_icon ' + modalIcon"></div>
		<p class="mb_40">{{ modalStatusMessage }}</p>
		<div class="button_area">
			<button
				v-if="status === 'success'"
				class="button_bg_red button_m"
				@click="messageModalCloseHandler"
			>
				{{ $t('rtr_auth-register.confirm') }}
			</button>
		</div>
	</ModalMessageM>
	<ModalViewM v-if="requestCheckModal" @closeModal="requestCheckModal = false">
		<template #title>
			<h3 class="modal_title_m">{{ $t('rtr_pay-deposit.text3') }}</h3>
		</template>
		<div class="bg_black_box mb_40">
			<div class="asset_box">
				<span :class="[selectedAccountInfo.asset_code, 'medium']"></span>
				<div>
					<p class="code mb_4">{{ selectedAccountInfo.asset_code }}</p>
					<p class="name">{{ selectedAccountInfo.asset_title }}</p>
				</div>
			</div>
			<span class="divide_line"></span>
			<div>
				<div class="black_box_item">
					<span class="fs_12">{{
						$t('rtr_activity-invoice.request_amount')
					}}</span>
					<span class="body_l">{{
						invoiceData.amount + ' ' + selectedAccountInfo.asset_code
					}}</span>
				</div>
				<div class="black_box_item">
					<span class="fs_12">{{ $t('rtr_activity-invoice.target') }}</span>
					<span class="body_l">{{ invoiceData.email }}</span>
				</div>
				<div class="black_box_item">
					<span class="fs_12">{{ $t('rtr_activity-invoice.item') }}</span>
					<span class="body_l">{{ invoiceData.title }}</span>
				</div>
				<!--				<div class="black_box_item ma_0">-->
				<!--					<span class="fs_12">지불 기일</span>-->
				<!--					<span class="body_l">{{-->
				<!--						$dayjs(invoiceData.endDate).format('YYYY.MM.DD')-->
				<!--					}}</span>-->
				<!--				</div>-->
			</div>
		</div>
		<div class="mb_40">
			<p>{{ $t('rtr_pay-deposit.text7') }}</p>
		</div>
		<button class="button_bg_red button_m" @click="sendInvoice">
			{{ $t('button.request') }}
		</button>
	</ModalViewM>
	<ModalViewM v-if="shareModal" @closeModal="shareModal = false">
		<template #title>
			<h3 class="modal_title_m tal">{{ shareModalData.title }}</h3>
		</template>
		<div class="qr_area">
			<div class="qr_image_wrap">
				<Qrcode
					id="qr"
					:color="{ dark: '#000000ff', light: '#ffffffff' }"
					type="image/png"
					:quality="1"
					:margin="1"
					:value="shareModalData.value"
				/>
			</div>
			<div class="qr_download">
				<a @click="qrDownload"
					><img
						src="@/assets/images/icon/download.png"
						alt="download button image"
					/>
					download</a
				>
			</div>
			<!--			<p class="address">{{ // selectedAccountInfo?.address }}</p>-->
			<p class="address">{{ shareModalData.value }}</p>
			<button class="button_copy" @click="copyShareModalValue">
				{{ $t('button.copy') }}
			</button>
		</div>
	</ModalViewM>
	<Tutorial v-if="showTutorial" @close="showTutorial = false"></Tutorial>
</template>

<script>
import '@/assets/css/payment.m.css';
import AccountPicker from '@/components/AccountPicker.vue';
import ModalViewM from '@/components/Layout/ModalView.m';
import ModalMessageM from '@/components/Layout/ModalMessage.m';
import Invoice from '@/components/User/Pay/Invoice';
import { mapGetters } from 'vuex';
import { Navigation } from 'swiper';
import useClipboard from 'vue-clipboard3';
import Tutorial from '@/components/Tutorial';
import Cookies from 'js-cookie';
import { createInvoice } from '@/api/deposit';
import { commonError } from '@/common/dialog';

export default {
	name: 'deposit.m',
	components: {
		AccountPicker,
		ModalViewM,
		ModalMessageM,
		Invoice,
		Tutorial,
	},
	props: {
		seq: {
			type: Number,
		},
	},
	data() {
		return {
			modules: [Navigation],
			showTab: null,
			selectedAccountSeq: 0,
			selectedWay: '',
			checked: false,
			messageModal: false,
			requestCheckModal: false,
			modalIcon: 'error',
			modalStatusMessage: '',
			sendAmount: null,
			shareModal: false,
			shareModalData: {
				title: '',
				value: '',
			},
			tour: null,
			showTutorial: false,
			invoiceData: {},
			status: '',
		};
	},
	computed: {
		...mapGetters('account', ['accounts']),
		...mapGetters('account', ['own_assets_group']),
		...mapGetters('assets', ['assets']),
		...mapGetters('auth', ['member_info']),
		...mapGetters('lang', ['lang']),

		ownAssetsItems() {
			let data = [];
			const group = Object.keys(this.own_assets_group).map(Number);
			this.assets.forEach(asset_item => {
				if (group.includes(asset_item.seq)) data.push(asset_item);
			});
			return data;
		},
		selectedAccountInfo() {
			return this.accounts.find(account => {
				return account.seq === parseInt(this.selectedAccountSeq);
			});
		},
	},
	watch: {
		selectedAccountInfo(info) {
			if (info.code === 'JPYS') {
				this.selectedWay = 'way1';
				this.showTab = 'way1';
			} else {
				this.selectedWay = 'way1';
				this.showTab = 'way1';
			}
		},
	},
	methods: {
		selectWay(e) {
			if (!this.selectedAccountInfo?.seq) {
				e.target.checked = false;
				this.modalIcon = 'error';
				this.modalStatusMessage = this.$t('modal.message.select_asset');
				this.messageModal = true;
				return;
			}
			this.showTab = e.target.id;
		},
		getAccountInfo(accountSeq) {
			this.selectedAccountSeq = accountSeq;
		},
		toDashboard() {
			this.$router.push({ name: 'auth-dashboard' });
		},
		validations() {
			if (!this.selectedAccountInfo) {
				this.modalStatusMessage = this.$t('modal.message.select_asset');
				return false;
			}
			if (!this.selectedWay) {
				this.modalStatusMessage = this.$t('modal.message.select_way');
				return false;
			}
			if (this.selectedWay === 'way2') {
				if (!this.selectedAccountInfo.address) {
					this.modalStatusMessage = this.$t('rtr_pay-deposit.text6');
					return false;
				}
			}
			if (this.selectedWay === 'way3') {
				if (!this.invoiceData.email) {
					this.modalStatusMessage = this.$t('rtr_pay-deposit.text8');
					return false;
				}
				if (!this.invoiceData.title) {
					this.modalStatusMessage = this.$t('rtr_pay-deposit.text9');
					return false;
				}
				if (!this.invoiceData.amount) {
					this.modalStatusMessage = this.$t('rtr_pay-deposit.text10');
					return false;
				}
				// if (!this.invoiceData.endDate) {
				// 	this.modalStatusMessage = '지불기한을 입력해 주세요.';
				// 	return false;
				// }
			}
			return true;
		},
		onRequestHandler() {
			if (this.selectedWay === 'way3') {
				if (!this.validations()) {
					this.status = 'check';
					this.modalIcon = 'error';
					this.messageModal = true;
					return;
				}
				this.requestCheckModal = true;
			} else {
				this.onShare();
			}
		},
		onShare() {
			if (!this.validations()) {
				this.modalIcon = 'error';
				this.messageModal = true;
				return;
			}
			if (this.selectedWay === 'way1') {
				this.shareModalData.title = this.$t('rtr_pay-deposit.my_account');
				this.shareModalData.value = this.selectedAccountInfo.account_number;
			}
			if (this.selectedWay === 'way2') {
				this.shareModalData.title = this.$t('rtr_pay-deposit.my_wallet');
				this.shareModalData.value = this.selectedAccountInfo.address;
			}
			this.shareModal = true;
		},
		async sendInvoice() {
			this.requestCheckModal = false;
			const params = {
				account_seq: this.selectedAccountSeq,
				title: this.invoiceData.title,
				applicant_email_address: this.invoiceData.email,
				net_amount: this.invoiceData.amount,
			};
			await createInvoice(params)
				.then(() => {
					this.status = 'success';
					this.modalIcon = 'success';
					this.modalStatusMessage = '자산 요청이 완료되었습니다.';
					this.messageModal = true;
				})
				.catch(commonError);
		},
		setInvoiceData(data) {
			this.invoiceData = data;
		},
		qrDownload() {
			const dataUrl = document.getElementById('qr').src;
			const link = document.createElement('a');
			link.href = dataUrl;
			link.download = 'qrcode';
			link.click();
		},
		copyShareModalValue() {
			try {
				useClipboard().toClipboard(this.shareModalData.value);
				alert(this.$t('alert.copy_s'));
			} catch (e) {
				alert(this.$t('alert.copy_f'));
			}
		},
		tutorialHandler() {
			if (!Cookies.get(this.$route.name + '_tutorial')) {
				this.showTutorial = true;
			}
		},
		messageModalCloseHandler(type) {
			if (this.selectedWay === 'way3') {
				if (type === 'close') {
					this.messageModal = false;
					if (this.status === 'success') {
						this.status = '';
						this.$refs.invoice.initForm();
					}
				} else {
					this.$router.push({
						name: 'activity-invoice',
						query: { accountSeq: this.selectedAccountSeq },
					});
				}
			} else {
				this.messageModal = false;
			}
		},
	},
	created() {
		if (this.$route.query.accountSeq) {
			this.selectedAccountSeq = this.$route.query.accountSeq;
		}
	},
	mounted() {
		this.tutorialHandler();
	},
};
</script>
<style scoped></style>
